import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import ClinicalPortal from "./ClinicalPortal";
import AuthGuard from "./components/AuthGuard";

// FIX (#27 → fix PR): the CRA build (src/index.js) — the entry Vercel actually
// ships — previously rendered <ClinicalPortal/> bare, so production had no auth
// gate / login and hung forever on ClinicalPortal's "Loading…" screen. The
// <AuthGuard> wrapper only existed on the Vite-only src/main.jsx → src/App.jsx
// path, which create-react-app never builds. Wrap it here, mirroring the
// structural wrap in src/App.jsx (<AuthGuard><ClinicalPortal/></AuthGuard>).
//
// Note: src/App.jsx also passes vestigial formComponents/supabaseHelpers props,
// but ClinicalPortal() takes no props and ignores them — and importing those
// helpers would pull App.jsx's missing './supabaseClient' exports into the CRA
// build and fail the CI build — so they're intentionally omitted here.
//
// [clinical-diag] Temporary diagnostics — see PR.
console.log("[clinical-diag] entry=src/index.js (CRA build) — rendering <AuthGuard><ClinicalPortal/></AuthGuard>");

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <AuthGuard>
      <ClinicalPortal />
    </AuthGuard>
  </React.StrictMode>
);
